import React, {useState} from 'react';
import Form from "react-bootstrap/Form"
import SmartInput from "./SmartInput";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import countries from "../../assets/countries.json"
import {FloatingLabel, FormControl} from "react-bootstrap";

function  SmartFormGroup(props) {
    const [groupState, setGroupState] = useState(null)
    const [helperText, setHelperText] = useState(false)
    const id=props?.id ? props.id : props.name
    const {editing, ...rest} = props

    const formatPlainTextValue = function(value){
        if (!props?.editing){
            switch(props.answer.type){
                case "choice":
                    const selected = props.answer.choices.find(choice=>{
                        return choice.value === props.defaultValue
                    })
                    const s =  selected ? selected.text:''
                    return s
                case "ddmmyyyy":
                    if (!props.defaultValue || props.defaultValue.toString().split('-').length !== 3){
                        return ''
                    }
                    return props.defaultValue.split('-').reverse().join(' / ')
                case "mmyyyy":
                    if (!props.defaultValue || props.defaultValue.toString().split('-').length !== 3){
                        return ''
                    }
                    let r= props.defaultValue.split('-')
                    r.pop()
                    return r.reverse().join(' / ')
                case "agearray":
                    return props.defaultValue.join(", ")
                case "euro":
                    let val = !props.defaultValue ? '' : '€' + props.defaultValue.toLocaleString('en-us')
                    return val
                case "nationality":
                    if (!props.defaultValue){
                        return ''
                    }
                    return countries.find(country=>country.alpha_2_code === props.defaultValue).nationality
                case "country":
                    if (!props.defaultValue){
                        return ''
                    }
                    return countries.find(country=>country.alpha_2_code === props.defaultValue).en_short_name
                default:
            }
        }
       return value
    }
    const body=function(){
        const helpText = groupState==='invalid' ? helperText : ''
        //const floatAttr = props?.floating && !props?.editing ? {floating:true}:{}
        return (
            <>
                {(props?.editing && props.editing) && (
                    <SmartInput
                        expandedStyle={props.expandedStyle}
                        groupState={groupState}
                        setGroupState={setGroupState}
                        setHelperText={setHelperText}
                        id={id}
                        {...rest}
                        editing={editing}
                    />
                )}
                {(!props?.editing && props?.floating ) && (
                    // <div className="form-floating">
                        <FloatingLabel controlId={`smartInput${props.id}`} label={props.label}>
                            <FormControl type="text" placeholder={props.label} className="form-control form-control-plaintext font-alt text-jumbo" value={formatPlainTextValue(props.defaultValue)} readOnly={true} disabled={true} />
                        </FloatingLabel>

                    // </div>
                )

                }
                {props.answer.type !== 'multichoice' && (

                    <div className="text-end small">
                        <Form.Text id={`helpBlock${id}`} className="text-danger">
                            {helpText}
                        </Form.Text>
                    </div>
                )


                }



            </>
        )
    }

    const labelWidth = props.answer.type === "textarea" && props.editing ? 'col-12 ':'col-5'
    const borderColor = !editing ? "":"border-white"
    if (props?.floating){
        return (
            <Row className={`${borderColor}`}>
                <Col className="">
                    {body()}
                </Col>
            </Row>
        )
    }
    if (props?.expandedStyle === 'wizard'){
        return (
            <Row className="d-flex flex-column">
                <Form.Label className={`mb-5 h4 transitionable delay-1 text-center`} as={Col} htmlFor={id}>{props.text}</Form.Label>
                <Col className="py-1">
                    {body()}
                </Col>
            </Row>
        );
    }
    if (props?.expandedStyle){
        return (
            <Row className="d-flex flex-column">
                <Form.Label className={`mb-3 mt-5 h5`} as={Col} htmlFor={id}>{props.text}</Form.Label>
                <Col className="py-1">
                    {body()}
                </Col>
            </Row>
        );
    }
    return (
        <Row className={`border-bottom align-items-center ${borderColor}`}>
            <Form.Label className={`mb-0 ${labelWidth}`} as={Col} htmlFor={id}>{props.label}</Form.Label>
            <Col className="py-1">
                {body()}
            </Col>

        </Row>
    );
}

export default SmartFormGroup;